import { render, staticRenderFns } from "./UnitsMenu.vue?vue&type=template&id=1fb7d4ee"
import script from "./UnitsMenu.ts?vue&type=script&lang=ts&external"
export * from "./UnitsMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./UnitsMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports